import { EventEmitter, Injectable, Output } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { Http, URLSearchParams } from '@angular/http';

@Injectable()
export class FondeadoresService {
  @Output() enviaBandera: EventEmitter<any> = new EventEmitter();
  private service_url;
  private service_url_folios;

  constructor(
    private constantsService: ConstantsService, 
    private http: Http,
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService
  ) { 
    this.service_url = this.constantsService.apiURL + '/fondeadores';
  }

  getDefaultSchedule() {
    return {
      'tipo_fondeador': '',
      'nombre': '',
      'apellido_paterno': '',
      'apellido_materno': '',
      'email':'',
      'idSucursal': '',
      'telefono': '',
      'tipo_entidad': '',
      'curp': '',
      'rfc': '',
      'direccion': '',
      'saldo': '',
      'clave_elector': '',
      'idPromotor': null,
      'plaza': '',
      'idEmpresa': '',
      'deposito_fondos':'',
      'nombre_banco':'',
      'numero_cuenta':'',
      'tipo_clabe_tarjeta':'',
      'num_clabe_tarjeta':'',
      'nombre_b1':'',
      'apellido_paterno_b1': '',
      'apellido_materno_b1': '',
      'email_b1':'',
      'telefono_b1':'',
      'parentesco_b1':'',
      'porcentaje_b1':'',
      'nombre_b2':null,
      'apellido_paterno_b2': null,
      'apellido_materno_b2': null,
      'email_b2':null,
      'telefono_b2':null,
      'parentesco_b2':null,
      'porcentaje_b2':null,
      'archivo_ine': null,
      'archivo_domicilio': null,
      'archivo_rfc': null,
      
    };
  }

  public validate(data){
    console.log("Validando... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
      //alert("Falta ingresar el nombre");
    }

    if(!this.validatorService.required(data["apellido_paterno"])){
      error["apellido_paterno"] = this.errorService.required;
      //alert("Falta ingresar el apellido paterno");
    }

    if(!this.validatorService.required(data["apellido_materno"])){
      error["apellido_materno"] = this.errorService.required;
      //alert("Falta ingresar el apellido materno");
    }

    // validacion de EMAIL
    data["email"] = data["email"].trim();
    // console.log("DataValidator: ", data);
    
    if(!this.validatorService.required(data["email"])){
      error["email"] = this.errorService.required;
      //alert("Falta ingresar email");
    }
    else if(!this.validatorService.max(data["email"], 40)){
      //error["email"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data['email'])) {
      //error['email'] = this.errorService.email;
    }

    if(!this.validatorService.required(data["idSucursal"])){
      error["idSucursal"] = this.errorService.required;
      //alert("Falta ingresar sucursal");
    }

    if(!this.validatorService.required(data["telefono"])){
      error["telefono"] = this.errorService.required;
      //alert("Falta ingresar teléfono del fondeador");
    }else if(!this.validatorService.numeric(data["telefono"])){
      error["telefono"] = this.errorService.numeric;
      //alert("El campo teléfono deben ser solo números");
    }else if(!this.validatorService.min(data["telefono"], 10)){
      error["telefono"] = this.errorService.min(10);
      //alert("La longitud de caracteres del teléfono es menor, deben ser 10");
    }else if(!this.validatorService.max(data["telefono"], 10)){
      error["telefono"] = this.errorService.max(10);
      //alert("La longitud de caracteres del teléfono es mayor, deben ser 10");
    }

    if(!this.validatorService.required(data["tipo_entidad"])){
      error["tipo_entidad"] = this.errorService.required;
      //alert("Falta ingresar tipo de entidad");
    }
    
    if(!this.validatorService.required(data["curp"])){
      error["curp"] = this.errorService.required;
      //alert("Falta ingresar CURP");
    }else if(!this.validatorService.min(data["curp"], 18)){
      error["curp"] = this.errorService.min(18);
      //alert("La longitud de caracteres de la CURP es menor, deben ser 18");
    }else if(!this.validatorService.max(data["curp"], 18)){
      error["curp"] = this.errorService.max(18);
      //alert("La longitud de caracteres de la CURP es mayor, deben ser 18");
    }

    if(!this.validatorService.required(data["rfc"])){
      error["rfc"] = this.errorService.required;
      //alert("Falta ingresar RFC");
    }else if(!this.validatorService.min(data["rfc"], 12)){
      error["rfc"] = this.errorService.min(12);
    }else if(!this.validatorService.max(data["rfc"], 13)){
      error["rfc"] = this.errorService.max(13);
    }

    if(!this.validatorService.required(data["direccion"])){
      error["direccion"] = this.errorService.required;
      //alert("Falta ingresar dirección");
    }

    // if(!this.validatorService.required(data["saldo"])){
    //   error["saldo"] = this.errorService.required;
    //   //alert("Falta ingresar saldo");
    // }
    //Validar clave de elector para personas físicas
    if(data["tipo_entidad"] === "fisica"){
      if(!this.validatorService.required(data["clave_elector"])){
        error["clave_elector"] = this.errorService.required;
        //alert("Falta ingresar clave de elector");
      }
    }
    if(!this.validatorService.required(data["tipo_fondeador"])){
      error["tipo_fondeador"] = this.errorService.required;
      //alert("Falta ingresar tipo de fondeador");
    }

    if(data["tipo_fondeador"] === "ahorrador"){
      if(!this.validatorService.required(data["idEmpresa"])){
        error["idEmpresa"] = this.errorService.required;
        //alert("Falta ingresar la empresa");
      }
    }

    if(data["tipo_fondeador"] === "inversionista"){
      if(!this.validatorService.required(data["plaza"])){
        error["plaza"] = this.errorService.required;
        //alert("Falta ingresar la plaza");
      }
    }

    if(!this.validatorService.required(data["deposito_fondos"])){
      error["deposito_fondos"] = this.errorService.required;
      //alert("Falta ingresar el medio de depósito");
    }
    //Validar que deposito fondos sea banco
    if(data["deposito_fondos"] === "transferencia"){

      if(!this.validatorService.required(data["nombre_banco"])){
        error["nombre_banco"] = this.errorService.required;
        //alert("Falta ingresar nombre del banco");
      }
  
      if(!this.validatorService.required(data["numero_cuenta"])){
        error["numero_cuenta"] = this.errorService.required;
        //alert("Falta ingresar número de cuenta");
      }else if(!this.validatorService.numeric(data["numero_cuenta"])){
        error["numero_cuenta"] = this.errorService.numeric;
        //alert("El número de cuenta deben ser solo números");
      }else if(!this.validatorService.max(data["numero_cuenta"], 10)){
        error["numero_cuenta"] = this.errorService.max(10);
        //alert("Se excedió la longitud del número de cuenta");
      }

      if(!this.validatorService.required(data["tipo_clabe_tarjeta"])){
        error["tipo_clabe_tarjeta"] = this.errorService.required;
        //alert("Falta ingresar si es tarjeta o cuenta CLABE");
      }
  
      if(!this.validatorService.required(data["num_clabe_tarjeta"])){
        error["num_clabe_tarjeta"] = this.errorService.required;
        //alert("Falta ingresar el número de tarjeta o CLABE");
      }else if(!this.validatorService.numeric(data["num_clabe_tarjeta"])){
        error["num_clabe_tarjeta"] = this.errorService.numeric;
        //alert("Los caracteres de tarjeta o cuenta CLABE deben ser solo números");
      }else if(!this.validatorService.min(data["num_clabe_tarjeta"], 16)){
        error["num_clabe_tarjeta"] = this.errorService.min(16);
        //alert("Los longitud de caracteres de tarjeta o cuenta CLABE deben ser 16");
      }else if(!this.validatorService.max(data["num_clabe_tarjeta"], 18)){
        error["num_clabe_tarjeta"] = this.errorService.max(18);
        //alert("Los longitud de caracteres de tarjeta o cuenta CLABE se excedió, deben ser 16");
      }
    }
    //Datos del beneficiario 1
    if(!this.validatorService.required(data["nombre_b1"])){
      error["nombre_b1"] = this.errorService.required;
      //alert("Falta ingresar nombre del beneficiario");
    }

    if(!this.validatorService.required(data["apellido_paterno_b1"])){
      error["apellido_paterno_b1"] = this.errorService.required;
      //alert("Falta ingresar apellido paterno del beneficiario");
    }

    if(!this.validatorService.required(data["apellido_materno_b1"])){
      error["apellido_materno_b1"] = this.errorService.required;
      //alert("Falta ingresar apellido materno del beneficiario");
    }

    if(!this.validatorService.required(data["email_b1"])){
      error["email_b1"] = this.errorService.required;
      //alert("Falta ingresar email del beneficiario");
    }
    else if(!this.validatorService.max(data["email_b1"], 40)){
      error["email_b1"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data['email_b1'])) {
      error['email_b1'] = this.errorService.email;
    }

    if(!this.validatorService.required(data["telefono_b1"])){
      error["telefono_b1"] = this.errorService.required;
      //alert("Falta ingresar teléfono del beneficiario");
    }else if(!this.validatorService.numeric(data["telefono_b1"])){
      error["telefono_b1"] = this.errorService.numeric;
    }else if(!this.validatorService.min(data["telefono_b1"], 10)){
      error["telefono_b1"] = this.errorService.min(10);
    }else if(!this.validatorService.max(data["telefono_b1"], 10)){
      error["telefono_b1"] = this.errorService.max(10);
    }

    if(!this.validatorService.required(data["parentesco_b1"])){
      error["parentesco_b1"] = this.errorService.required;
      //alert("Falta ingresar parentesco del beneficiario");
    }

    if(!this.validatorService.required(data["porcentaje_b1"])){
      error["porcentaje_b1"] = this.errorService.required;
      //alert("Falta ingresar porcentaje del beneficiario");
    }

    // if(!this.validatorService.required(data["idProductoFinanciero"])){
    //   error["idProductoFinanciero"] = this.errorService.required;
    //   alert("Falta seleccionar el producto financiero");
    // }

    // if(!this.validatorService.required(data["monto"])){
    //   error["monto"] = this.errorService.required;
    //   alert("Falta ingresar el monto de inversión");
    // }

    // if(!this.validatorService.required(data["fecha_inicio_inversion"])){
    //   error["fecha_inicio_inversion"] = this.errorService.required;
    //   alert("Falta seleccionar la fecha de inicio de inversión");
    // }

    // if(!this.validatorService.required(data["fecha_fin_inversion"])){
    //   error["fecha_fin_inversion"] = this.errorService.required;
    // }

    // if(!this.validatorService.required(data["capitalizacion"])){
    //   error["capitalizacion"] = this.errorService.required;
    //   alert("Falta seleccionar si capitaliza o es retiro mensual de intereses");
    // }
    
    // if(!this.validatorService.required(data["retencion_impuestos"])){
    //   error["retencion_impuestos"] = this.errorService.required;
    //   alert("Falta seleccionar si retiene impuestos");
    // }
    
    // if(data["retencion_impuestos"] === "si"){
    //   if(!this.validatorService.required(data["tasa_retencion"])){
    //     error["tasa_retencion"] = this.errorService.required;
    //     alert("Falta ingresar la tasa de retención de impuestos");
    //   }
    // }

    return error;
  }

  public validateEsquema(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["idProductoFinanciero"])){
      error["idProductoFinanciero"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["monto"])){
      error["monto"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["fecha_inicio_inversion"])){
      error["fecha_inicio_inversion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["fecha_fin_inversion"])){
      error["fecha_fin_inversion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["capitalizacion"])){
      error["capitalizacion"] = this.errorService.required;
    }
    
    if(!this.validatorService.required(data["retencion_impuestos"])){
      error["retencion_impuestos"] = this.errorService.required;
    }
    
    if(data["retencion_impuestos"] === "si"){
      if(!this.validatorService.required(data["tasa_retencion"])){
        error["tasa_retencion"] = this.errorService.required;
      }
    }

    return error;
  }

  public validateUpdate(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
    }

    // validacion de EMAIL
    data["email"] = data["email"].trim();
    console.log("DataValidator: ", data);
    
    if(!this.validatorService.required(data["email"])){
      error["email"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["email"], 40)){
      error["email"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data['email'])) {
      error['email'] = this.errorService.email;
    }
    
    if(!this.validatorService.required(data["telefono"])){
      error["telefono"] = this.errorService.required;
    }else if(!this.validatorService.numeric(data["telefono"])){
      error["telefono"] = this.errorService.numeric;
    }else if(!this.validatorService.min(data["telefono"], 10)){
      error["telefono"] = this.errorService.min(10);
    }else if(!this.validatorService.max(data["telefono"], 10)){
      error["telefono"] = this.errorService.max(10);
    }

    //Validar que deposito fondos sea banco
    if(data["deposito_fondos"] === "banco"){

      if(!this.validatorService.required(data["nombre_banco"])){
        error["nombre_banco"] = this.errorService.required;
      }
  
      if(!this.validatorService.required(data["numero_cuenta"])){
        error["numero_cuenta"] = this.errorService.required;
      }else if(!this.validatorService.numeric(data["numero_cuenta"])){
        error["numero_cuenta"] = this.errorService.numeric;
      }else if(!this.validatorService.max(data["numero_cuenta"], 10)){
        error["numero_cuenta"] = this.errorService.max(10);
      }
  
      if(!this.validatorService.required(data["num_clabe_tarjeta"])){
        error["num_clabe_tarjeta"] = this.errorService.required;
      }else if(!this.validatorService.numeric(data["num_clabe_tarjeta"])){
        error["num_clabe_tarjeta"] = this.errorService.numeric;
      }else if(!this.validatorService.min(data["num_clabe_tarjeta"], 16)){
        error["num_clabe_tarjeta"] = this.errorService.min(16);
      }else if(!this.validatorService.max(data["num_clabe_tarjeta"], 18)){
        error["num_clabe_tarjeta"] = this.errorService.max(18);
      }
    }
    return error;
  }

  public obtenerListadePromotores(){
    return this.http.get(this.constantsService.apiURL+"/listadopromotores", this.authService.getAuthHeaders());
  }

  public obtenerFoliosdeFondeador(idFondeador){
    return this.http.get(this.constantsService.apiURL+"/profinbox/foliosmes?idFondeador="+idFondeador, this.authService.getAuthHeaders());
  }

  public registrarFondeador(data) {
    return this.http.post(this.service_url+"/registro-fondeador", data, this.authService.getAuthHeaders());
  }

  //Registrar socio con esquema de inversión
  public registrarSocioFondeador(data) {
    return this.http.post(this.service_url+"/registro/socio-fondeador", data, this.authService.getAuthHeaders());
  }

  // public obtenerFondeadores(){
  //   return this.http.get(this.service_url+"/lista-fondeadores?", this.authService.getAuthHeaders());
  // }

  //Obtener fondeadores con paginación
  public obtenerFondeadores(page:any, filters:any) {
    let myParams = new URLSearchParams();
    if(filters.page){
      myParams.append('paginate', 'true');
      myParams.append('page', filters.page);
    }
    if(filters.search){
      myParams.append('search', filters.search);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_url +"/lista-fondeadores" , myoptions);
    
    // if (page) {
    //   return this.http.get(this.service_url+"/lista-fondeadores" + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    // }
    // return this.http.get(this.service_url +"/lista-fondeadores"+ '?paginate=true', this.authService.getAuthHeaders());
  }
  //Obtiene todos los fondeadores en general sin paginate
  public getSelect() {
    return this.http.get(this.service_url +"/lista-fondeadores" + '?select=true', this.authService.getAuthHeaders());
  }

  //Obtiene fondeador especifico
  public getFondeadorEspecifico(id){
    return this.http.get(this.service_url +"/registro-fondeador?idFondeador="+id, this.authService.getAuthHeaders());
  }

  public getFondeadorById(id){
    return this.http.get(this.service_url +"/perfil-fondeador?idFondeador="+id, this.authService.getAuthHeaders());
  }
  public getInversionesId(id){
    return this.http.get(this.service_url +"/perfil-fondeador/inversiones?idFondeador="+id, this.authService.getAuthHeaders());
  }

  //Obtener esquema de inversión por ID
  public getEsquemaInversionById(id){
    return this.http.get(this.service_url +"/detalles-inversion?idEsquemaInversion="+id, this.authService.getAuthHeaders());
  }

  //Obtener esquema de inversión por ID con incrementos de inversión
  public getEsquemaInversionConIncrementos(idInversion){
    return this.http.get(this.service_url +"/detalles-inversion/incrementos?idEsquemaInversion="+idInversion, this.authService.getAuthHeaders());
  }

  //Obtener esquema de inversión por ID con devoluciones de inversión
  public getEsquemaInversionConDevoluciones(idInversion){
    return this.http.get(this.service_url +"/detalles-inversion/devoluciones?idEsquemaInversion="+idInversion, this.authService.getAuthHeaders());
  }

  update(id, data) {
    return this.http.put(this.service_url +'?id='+ id, data, this.authService.getAuthHeaders());
  }

  public delete(id) {
    return this.http.delete(this.service_url +'?id='+ id, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  search(search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fondeadores.service.ts